import './instrument';
import { StrictMode } from 'react';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { createRoot } from 'react-dom/client';
import { setDefaultOptions } from 'date-fns';
import { es } from 'date-fns/locale';
import * as Sentry from '@sentry/react';
import { prefetchLazyRoutes } from '@repo/ui/lib/lazy-route';

import { routes } from './routes';

import './index.css';

setDefaultOptions({
  locale: es,
});

const router = createBrowserRouter(routes);
prefetchLazyRoutes(router);

const container = document.getElementById('root')!;

const root = createRoot(container, {
  onUncaughtError:
    process.env.NODE_ENV === 'production'
      ? Sentry.reactErrorHandler((error, errorInfo) => {
          console.warn('Uncaught error', error, errorInfo.componentStack);
        })
      : undefined,
  onCaughtError: process.env.NODE_ENV === 'production' ? Sentry.reactErrorHandler() : undefined,
  onRecoverableError:
    process.env.NODE_ENV === 'production' ? Sentry.reactErrorHandler() : undefined,
});

root.render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
